const AppLogoFull = ({ height = 36, className = '' }) => (
  <img
    src="/logo-fretmanager.png"
    alt="FretManager"
    className={className}
    style={{ height, width: 'auto', objectFit: 'contain', display: 'block' }}
  />
);

export default AppLogoFull;
